var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rooted"},[_c('img',{attrs:{"src":_vm.loyaltyBySable,"width":"142","height":"100"}}),_c('img',{attrs:{"src":_vm.sableLoading,"width":"142","height":"130"}})])}
var staticRenderFns = []

export { render, staticRenderFns }